module.exports = __webpack_public_path__ + "static/app-store-light-f6cf1e5649e7661d22de162fe1c6bbcb.svg";